/**
 * Constants for input paginations
 */

const defaultPagination = {
  PAGE_INDEX: 0,
  PAGE_SIZE: 30,
  PAGE_SIZE_AUTOCOMPLETE: 100
};

export const DEFAULT_PAGINATION = defaultPagination;
